"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardBody = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardBodyMixin = require("../../mixins/components/PropertyCardBodyMixin");
var _Card = require("../Card/Card");
var StyledPropertyCardBody = /*#__PURE__*/(0, _styledComponents.default)(_Card.Card).withConfig({
  displayName: "StyledPropertyCardBody",
  componentId: "c11n-8-107-0__sc-1danayh-0"
})(["", ""], _PropertyCardBodyMixin.PropertyCardBodyMixin);
exports.StyledPropertyCardBody = StyledPropertyCardBody;